import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import OrderSellerRemarksFlag from "@/enum/OrderSellerRemarksFlag";
import { get } from "@/services/http/platformServer";

export interface HistorySellerRemarkDto {
    orderOriginalId: string;
    content: string;
    flag: OrderSellerRemarksFlag;
    flagTag: string;
    operator: string;
    timestamp: number;
}

export function getTbOrderHistorySellerRemarks(
    shopId: number,
    originalId: string,
    mergeSplitStatus: OrderMergeSplitStatus,
) {
    return get<HistorySellerRemarkDto[]>(shopId, "/taobao/order/get_history_seller_remarks", {
        shopId,
        originalId,
        mergeSplitStatus,
    });
}

export interface SellerFlagDto {
    /**
     * 旗帜
     */
    flag: OrderSellerRemarksFlag;
    /**
     * 旗帜标签内容
     */
    flagTag: string;
}

export function getTbOrderSellerFlags(shopId: number) {
    return get<SellerFlagDto[]>(shopId, "/taobao/order/get_seller_flags", { shopId });
}
